const ALLOWED_PATH_PREFIXES = [
  '/dashboard',
  '/users',
  '/companies',
  '/employees',
  '/departments',
  '/teams',
  '/appstore',
  '/audit',
  '/settings',
  '/roles',
];

const DEFAULT_REDIRECT = '/dashboard';

export function sanitizeRedirectPath(path: string | null | undefined): string {
  if (!path || typeof path !== 'string') {
    return DEFAULT_REDIRECT;
  }

  const trimmed = path.trim();

  if (trimmed === '') {
    return DEFAULT_REDIRECT;
  }

  if (trimmed.startsWith('//')) {
    return DEFAULT_REDIRECT;
  }

  if (trimmed.startsWith('javascript:') || trimmed.startsWith('data:')) {
    return DEFAULT_REDIRECT;
  }

  if (!trimmed.startsWith('/')) {
    return DEFAULT_REDIRECT;
  }

  const isAllowedPath = ALLOWED_PATH_PREFIXES.some((prefix) => trimmed.startsWith(prefix));

  if (!isAllowedPath) {
    return DEFAULT_REDIRECT;
  }

  return trimmed;
}
